import { useEffect, useState } from 'react';

/** Coincide con el breakpoint `md` de Tailwind (< 768px). */
export const MOBILE_CALENDAR_MQ = '(max-width: 767px)';

export const useIsMobileCalendar = () => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia(MOBILE_CALENDAR_MQ).matches;
    });

    useEffect(() => {
        const media = window.matchMedia(MOBILE_CALENDAR_MQ);
        const sync = (event) => setIsMobile(event.matches);
        sync(media);
        media.addEventListener('change', sync);
        return () => media.removeEventListener('change', sync);
    }, []);

    return isMobile;
};
